import React from "react";

const CLS = {
  "A+":       "bg-emerald-500/25 text-emerald-200 border-emerald-500/40",
  "A":        "bg-emerald-500/20 text-emerald-300 border-emerald-500/30",
  "B":        "bg-teal-500/15 text-teal-300 border-teal-500/25",
  "C":        "bg-blue-500/15 text-blue-300 border-blue-500/25",
  "D":        "bg-amber-500/15 text-amber-300 border-amber-500/25",
  "Low":      "bg-zinc-500/15 text-zinc-400 border-zinc-500/25",
  "Closed":   "bg-zinc-500/15 text-zinc-400 border-zinc-500/25",
};

const TIPS = {
  "A+": "A+ · Exceptional opportunity — top-tier score, multiple aligned high-quality traders, room to enter.",
  "A":  "A · Strong opportunity — meaningful edge remains, high alignment.",
  "B":  "B · Moderate opportunity — worth investigating.",
  "C":  "C · Marginal opportunity — limited edge or weaker conviction.",
  "D":  "D · Weak opportunity — mostly signals a story to watch, not to act on.",
  "Low": "Low signal quality or insufficient data.",
  "Closed": "Market is closed — no further edge.",
};

export default function OpportunityBadge({ rating, size = "sm", testid }) {
  const tip = TIPS[rating] || "Composite opportunity rating derived from score and actionability.";
  if (!rating) {
    return (
      <span data-testid={testid} title={tip}
        className="inline-flex items-center rounded-md border border-zinc-700 bg-zinc-800/40 text-zinc-500 px-1.5 py-0.5 text-[10px] font-mono-num uppercase tracking-wider">
        —
      </span>
    );
  }
  const cls = CLS[rating] || CLS.Low;
  return (
    <span data-testid={testid} title={tip}
      className={`inline-flex items-center rounded-md border ${cls} ${
        size === "lg" ? "px-2.5 py-1 text-base font-semibold" : "px-1.5 py-0.5 text-xs"
      } font-heading tracking-tight`}>
      {rating}
    </span>
  );
}
